export default __webpack_public_path__ + "static/img3-7ad354e0577bfe2b7139acc8819a5104.png";